import React from 'react';

const HomeIcon = () => {
    return (
        <svg
            className='dark:fill-blac'
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 64 64"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M63.28 24.46L53 15.9V9a2 2 0 00-4 0v3.56L35.84 1.6a6 6 0 00-7.68 0L.72 24.46a2 2 0 002.56 3.08L30.72 4.67a2 2 0 012.56 0L56 23.6V58a2 2 0 01-2 2H44V38a6 6 0 00-6-6H26a6 6 0 00-6 6v22H10a2 2 0 01-2-2V34a2 2 0 00-4 0v24a6 6 0 006 6h44a6 6 0 006-6V26.94l.72.6A2 2 0 0062 28a2 2 0 001.28-3.54zM24 60V38a2 2 0 012-2h12a2 2 0 012 2v22z"
                data-original="#7F7474"
                
            ></path>
            <circle
                xmlns="http://www.w3.org/2000/svg"
                cx="30"
                cy="48"
                r="2"
                data-original="#7F7474"
                
            ></circle>
        </svg>
    );
}

export default HomeIcon;
